import styled from 'styled-components';
import { color, fontSize, fontWeight, spacing } from 'theme';

export const StyledTableContainer = styled.div`
  max-width: 100%;
  overflow-x: auto;
`;

export const StyledTable = styled.div`
  display: grid;
  grid-template-columns: auto auto repeat(2, minmax(0, 1fr));
  margin-bottom: ${spacing('md')};
  min-width: 750px;
`;

export const StyledCell = styled.div`
  padding: ${spacing('lg')} ${spacing('md')};
  border-bottom: 1px solid ${color('midnight_200')};
  font-size: ${fontSize('sm')};

  &.hasChart {
    padding: ${spacing('xs')} ${spacing('md')};
  }

  .recharts-label {
    font-size: ${fontSize('xs')};
  }
`;

export const StyledHeader = styled.div`
  padding: ${spacing('lg')} ${spacing('md')};
  border-bottom: 1px solid ${color('midnight_200')};
  border-top: 1px solid ${color('midnight_200')};
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
`;
